import simplify from "simplify-js";
import { SIMPLIFY_OPT } from "./constants.js";

export function simplifyPath({ paper_scope, path, tolerance }) {
  const points = path.clone({ insert: false }).segments.map((seg) => ({
    x: seg.point.x,
    y: seg.point.y,
  }));

  const simplified_points = simplify(points, tolerance, true);

  return new paper_scope.Path(simplified_points, {
    insert: false,
  });
}

export function getCurveLength(curve) {
  return curve.length;
}

export function splitCurveRecursively(curve, limit) {
  if (getCurveLength(curve) <= limit) {
    return [curve];
  } else {
    const t = 0.5;
    const right_curve = curve.divideAtTime(t);
    const left_curve = curve;

    const left_curves = splitCurveRecursively(left_curve, limit);
    const right_curves = splitCurveRecursively(right_curve, limit);

    return left_curves.concat(right_curves);
  }
}

export function limitPathCurvesSplitting(paper_scope, path, limit) {
  const splitted_path = new paper_scope.Path({ insert: false });

  const curves = [...path.clone({ insert: false }).curves];
  const new_curves = [];

  while (curves.length > 0) {
    const current_curve = curves.shift();
    const splitted_curves = splitCurveRecursively(current_curve, limit);

    new_curves.push(...splitted_curves);
  }

  for (const curve of new_curves) {
    splitted_path.add(curve.segment1);
  }

  return splitted_path;
}

export function handlingSimplify({ paper_scope, path }) {
  const is_need_simplify =
    path.segments.length > SIMPLIFY_OPT.segments ||
    (path.segments.length / path.area) * 100 ** 2 > SIMPLIFY_OPT.density;

  // console.log({
  //   is_need_simplify,
  //   len: path.segments.length,
  //   density: Math.round((path.segments.length / path.area) * 100 ** 2),
  // });

  if (is_need_simplify) {
    const splitted_path = limitPathCurvesSplitting(paper_scope, path, 5);
    splitted_path.closed = true;

    const simplified_path = simplifyPath({
      paper_scope,
      path: splitted_path,
      tolerance: SIMPLIFY_OPT.tolerance,
    });
    simplified_path.closed = true;

    return simplified_path;
  }
}
